import {ChangeEvent, FC} from 'react';
import {
	extractResidentCodeDigits,
	formatResidentCodeDisplay,
	ResidentCodeStepValues,
} from '../../model';
import {StepLayout} from 'features/registration';
import {TextInput} from '../components/TextInput';
import styles from './ResidentCodeStep.module.css';

type Props = {
	values: ResidentCodeStepValues;
	onChange: (patch: Partial<ResidentCodeStepValues>) => void;
	onHowToGet?: () => void;
};

export const ResidentCodeStep: FC<Props> = ({values, onChange, onHowToGet}) => {
	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange({code: extractResidentCodeDigits(event.target.value), skipped: false});
	};

	return (
		<StepLayout variant="fill">
			<StepLayout.Intro title="Введите код сертификата резидента РФ" compact />

			<StepLayout.Content className={styles.field}>
				<TextInput
					name="residentCode"
					className={styles.codeInput}
					value={formatResidentCodeDisplay(values.code)}
					placeholder="0000 0000 0000 0000"
					inputMode="numeric"
					autoComplete="off"
					onChange={handleChange}
					onClear={() => onChange({code: '', skipped: false})}
				/>
				<StepLayout.TextLink type="button" onClick={onHowToGet}>
					Как получить код сертификата
				</StepLayout.TextLink>
			</StepLayout.Content>
		</StepLayout>
	);
};
